<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}特设费用
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button v-if="showAdd || (showEdit && formData.id != null)" type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  特设费用名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.name" clearable/>
                </td>
                <th>
                  型号
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.spec" clearable/>

                </td>
                <th>
                  <em class="f-red">*</em>
                  金额/单位
                </th>
                <td style="display: flex;flex-direction: row;justify-content: space-between;">
                  <el-input style="width: 49%!important;" type="number" oninput="if(value<0||value>9999)value=0" autocomplete="off"
                            v-model="formData.price" clearable/>

                            <el-input style="width: 49%!important;" type="text" autocomplete="off" v-model="formData.unit" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  启用
                </th>
                <td>
                  <el-select v-model="formData.stat">
                    <el-option label="禁用" :value="0"/>
                    <el-option label="启用" :value="1"/>
                  </el-select>
                </td>
                <!-- <th>
                  <em class="f-red">*</em>
                  计价
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.unit" clearable/>
                </td> -->
              </tr>
              <tr>

              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                费用分类
                </th>
                <td>
                  <fee-type-select :big-id.sync="formData.bigFeeTypeId"
                                   :small-id.sync="formData.smallFeeTypeId"
                  />
                </td>
                   <th>
                  <em class="f-red">*</em>
                  类型
                </th>
                <td>
                  <el-select v-model="formData.feeType">
                    <el-option label="向公司申请" :value="1"/>
                    <el-option label="向用户收取" :value="2"/>
                  </el-select>
                </td>
                <th>
                  <em class="f-red">*</em>
                  有效时间
                </th>
                <td colspan="3">
                  <el-date-picker v-model="formData.date" type="daterange" range-separator="至" start-placeholder="开始日期"
                                  value-format="yyyy-MM-dd"
                                  style="width:100%" end-placeholder="结束日期">
                  </el-date-picker>
                </td>

              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>

                <th>
                  是否微信使用
                </th>
                <td>
                  <el-select v-model="formData.isWxUse"  >
                    <el-option label="否" :value="0" />
                    <el-option label="是" :value="1" />
                  </el-select>
                </td>
                <th>
                  编码
                </th>
                <td>
                 <el-input type="text" autocomplete="off" v-model="formData.encoded" clearable/>
                </td>
              </tr>
               <tr>
                <th>主图</th>
                <td>
                  <div>
                     <photoUpload :photo-url.sync="formData.mainImg" />
                  </div>
                </td>
                <th>详情图</th>
                <td>
                  <div>
                     <photoUpload :photo-url.sync="formData.detailImg" />
                  </div>
                </td>
                 <th>备注说明</th>
                 <td>
                   <div>
                     <el-input type="text" autocomplete="off" v-model="formData.note" clearable/>
                   </div>
                 </td>

                 <!--                <th>-->
<!--                  规格名称-->
<!--                </th>-->
<!--                <td>-->
<!--                  <el-select v-model="formData.specName"  >-->
<!--                    <el-option label="长度" :value="'长度'" />-->
<!--                    <el-option label="直径" :value="'直径'" />-->
<!--                  </el-select>-->
<!--                </td>-->
<!--                <th>-->
<!--                  规格值-->
<!--                </th>-->
<!--                <td>-->
<!--                 <el-input type="text" autocomplete="off" v-model="formData.specValue" clearable/>-->
<!--                </td>-->

              </tr>
              </tbody>
            </table>
          </div>

          <div style="display: flex;">
            <div class="d-item">
              <div class="title first" style="display: flex;flex-direction: row;
    justify-content: space-between;">
                <b>费用条件</b>
                      <div class="item-button">
                        <el-button type="primary" class="button-sty btn_zdy" @click="showItemPop=true">
                          <i class="el-icon-plus"></i>
                          产品
                        </el-button>&nbsp;
                        <el-button
                                   type="primary" class="button-sty btn_zdy" @click="handleDeleteItemList">
                          <i class="el-icon-delete"></i>
                          批量删除
                        </el-button>
                        <el-button
                          type="primary" class="button-sty btn_zdy" @click="buttonAddClickEvent">
                          <i class="el-icon-plus"></i>
                          新增地址
                        </el-button>
                  </div>
              </div>

              <div style="display: flex; width: 100%; justify-content: space-around;" >
                <div class="current-info" >
                  <!--保修类型-->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    ref="guaranteeTypeTable"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true, padding: 0, keyField: 'id', }"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    :checkbox-config="{checkAll:formData.isAllGuaranteeType===1,checkRowKeys:formData.selectedGuaranteeTypeIdList, highlight: false}"
                    :data="guaranteeTypeList"
                    @checkbox-change="guaranteeTypeSelectChangeEvent"
                    @checkbox-all="guaranteeTypeSelectChangeEvent"
                  >
                    <vxe-column type="checkbox" field="id" width="40"></vxe-column>
                    <vxe-column field="type" width="120" title="保修类型"></vxe-column>
                  </vxe-table>
                </div>
                <div class="current-info" >
                  <!--品牌-->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true, padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    ref="brandTable"
                    :checkbox-config="{labelField: 'name',checkAll:formData.isAllBrand===1, checkRowKeys: formData.selectedBrandIdList}"
                    :data="formData.snCompanyBrandList"
                    @checkbox-change="brandSelectChangeEvent"
                    @checkbox-all="brandSelectChangeEvent"
                  >
                    <vxe-column type="checkbox" width="40"></vxe-column>
                    <vxe-column field="brandName" width="120" title="品牌"></vxe-column>
                  </vxe-table>
                </div>
                <div class="current-info" style="width:240px;">
                  <!--产品类型-->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true,padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    ref="itemCategoryTable"
                    :tree-config="{transform: true}"
                    :checkbox-config="{labelField: 'name',checkAll:formData.isAllItemCategory===1, checkRowKeys: formData.selectedItemCategoryIdList}"
                    :data="formData.itemCategoryList"
                    @checkbox-change="itemCategorySelectChangeEvent"
                    @checkbox-all="itemCategorySelectChangeEvent"
                  >
                    <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                    <vxe-column field="categoryName" width="150" title="产品类型"></vxe-column>
                  </vxe-table>
                </div>
                <div class="current-info" style="width:240px;">
                  <!-- 服务类型 -->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true,padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    ref="serviceTypeTable"
                    :tree-config="{transform: true}"
                    :checkbox-config="{labelField: 'name',checkAll:formData.isAllServiceType===1, checkRowKeys: formData.selectedServiceTypeIdList}"
                    :data="formData.serviceTypeList"
                    @checkbox-change="serviceTypeSelectChangeEvent"
                    @checkbox-all="serviceTypeSelectChangeEvent"
                  >
                    <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                    <vxe-column field="serviceTypeName" width="150" title="服务类型"></vxe-column>
                  </vxe-table>
                </div>
<!--                <div class="current-info" >-->
<!--                  <vxe-table ref="filterTable" height="260"-->
<!--                             class="table_item pic_item mytable-scrollbar"-->
<!--                             :column-config="{ resizable: true }"-->
<!--                             style="width: 100%;"-->
<!--                             :stripe="true"-->
<!--                             :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"-->
<!--                             :row-config="{height: 40,isHover: true,padding: 0,}"-->
<!--                             :row-style="{ fontSize: '12px' }"-->
<!--                             show-overflow-->
<!--                             :data="specList"-->
<!--                             @checkbox-all="itemSelectChangeEvent"-->
<!--                             @checkbox-change="itemSelectChangeEvent"-->
<!--                  >-->
<!--                    <vxe-column field="specName" title="规格名称" width="140">-->
<!--                      <template #default="{ row }">-->
<!--                        <vxe-select v-model="row.specName" placeholder="请选择规格" clearable transfer>-->
<!--                          <vxe-option :disabled="isOptionDisabled(row, '1')"  value="1" label="长度"></vxe-option>-->
<!--                          <vxe-option :disabled="isOptionDisabled(row, '2')"   value="2" label="直径"></vxe-option>-->
<!--                        </vxe-select>-->
<!--                      </template>-->
<!--                    </vxe-column>-->
<!--                    <vxe-column field="specValue" title="规格值" width="150">-->
<!--                      <template #default="{ row }">-->
<!--                        <vxe-input v-model="row.specValue" placeholder="请输入规格值规格值" clearable></vxe-input>-->
<!--                      </template>-->
<!--                    </vxe-column>-->
<!--                  </vxe-table>-->

<!--                </div>-->
                <div class="current-info" >
                  <vxe-table ref="filterTable" height="260"
                             class="table_item pic_item mytable-scrollbar"
                             :column-config="{ resizable: true }"
                             style="width: 100%;"
                             :stripe="true"
                             :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{height: 40,isHover: true,padding: 0,}"
                             :row-style="{ fontSize: '12px' }"
                             show-overflow
                             :data="itemList"
                             @checkbox-all="itemSelectChangeEvent"
                             @checkbox-change="itemSelectChangeEvent"
                  >
                    <vxe-column type="checkbox" width="40"/>
                    <vxe-column field="itemName" title="产品名称" width="180"/>
                    <vxe-column field="itemCode" title="产品编码" width="140"/>
                    <vxe-column title="操作" width="60">
                      <template #default="{row}">
                        <div @click="handleDeleteItem(row.id)">
                          <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                      popper-class="tooltip-skin">
                            <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>

                </div>

                <div class="current-info" style="max-height: 350px;overflow-y: scroll">
                    <!-- 地区 -->
<!--                    <el-cascader style="width: 100%" :props="cascaderProps" v-model="cascaderValue"  clearable @change="cascaderChange"></el-cascader>-->
<!--                    <el-tree-->
<!--                      ref="areaTree"-->
<!--                      show-checkbox-->
<!--                      node-key="id"-->
<!--                      :load="treeLoadNode"-->
<!--                      lazy-->
<!--                      :check-strictly="true"-->
<!--                      :props="{label: 'areaName'}"-->
<!--                      @check="treeCheck"-->
<!--                    >-->
<!--                    </el-tree>-->
                  <vxe-table
                    class="mytable-scrollbar"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true,padding: 0,keyField: 'id', }"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260"
                    :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    ref="areaTable"
                    :data="selectedAreaList"
                  >
                    <vxe-column field="areaName" width="200" title="地区"></vxe-column>
                    <vxe-column field="options" width="120" title="操作">
                      <template #default="{row}">
                        <el-button type="primary" class="button-sty btn_zdy" @click="areaItemDel(row)">删除</el-button>
                      </template>
                    </vxe-column>
                  </vxe-table>

                  <el-dialog
                    title="选择地区"
                    :visible.sync="areaDialogVisible"
                    width="50%">
                    <div style="width: 100%;display: flex;">
                      <el-button
                        type="primary" class="button-sty btn_zdy" @click="areaDialogAdd" style="margin-bottom: 10px">
                        <i class="el-icon-plus"></i>
                        确认
                      </el-button>
                    </div>
                    <el-cascader ref="cascader" style="width: 80%" :props="cascaderProps" clearable @change="cascaderChange"></el-cascader>
<!--                    <vxe-table-->
<!--                      class="mytable-scrollbar"-->
<!--                      :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"-->
<!--                      :row-config="{height: 30,isHover: true,padding: 0,keyField: 'id', }"-->
<!--                      :row-style="{ fontSize: '12px',  }"-->
<!--                      show-overflow-->
<!--                      height="260" :column-config="{ resizable: true }"-->
<!--                      resizable-->
<!--                      row-id="id"-->
<!--                      ref="areaTable"-->
<!--                      :tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasChild', loadMethod: loadChildrenMethod}"-->
<!--                      :checkbox-config="{labelField: 'name',}"-->
<!--                      :data="areaList"-->
<!--                      @checkbox-change="areaSelectChangeEvent"-->
<!--                      @checkbox-all="areaSelectChangeEvent"-->
<!--                    >-->
<!--                      <vxe-column type="checkbox" width="150" :tree-node="true">-->
<!--                      </vxe-column>-->
<!--                      <vxe-column field="areaName" title="地区"></vxe-column>-->
<!--                    </vxe-table>-->
                  </el-dialog>
                  </div>


              </div>

            </div>

          </div>
        </div>
      </div>
    </el-form>
    <item-pop v-if="showItemPop"
              :visiable.sync="showItemPop"

              @confirm="commitSelectedRow"
              :excludeList="itemList"
    />
  </div>
</template>
<script>

import api from "@/api/projectApi";
import itemPop from "@/components/pop/checkboxItemPop.vue"
import ItemCategorySelect from "@/components/formItem/itemCategorySelect.vue"
import FeeTypeSelect from "@/components/formItem/feeTypeSelect.vue";
import {mapGetters} from "vuex";
import PhotoUpload from "@/components/formItem/photoUpload.vue";


export default {
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    FeeTypeSelect,
    PhotoUpload,
    itemPop,ItemCategorySelect
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  data() {
    return {
      selectedAreaList: [],
      areaList: [],
      showGuaranteeTypeList: true,
      showItemPop: false,
      showEdit: false,
      showAdd: false,
      activeName: 'first',
      isEdit: false,
      dataId: '',
      formData: {
        id: null,  // 主键id,自动新增
        feeType: 1,  // 类型:1向公司申请;2向用户收取
        price: 0,  // 金额
        stat: 1,  // 启用:0禁用；1启用

        selectedItemCategoryIdList: [],
        selectedServiceTypeIdList: [],
        selectedBrandIdList: [],
        selectedGuaranteeTypeIdList:[],
        basItemIdList:[],
        isAllGuaranteeType:0,
        isAllBrand:0,
        isAllItemCategory:0,
        isAllServiceType:0,
        isAllItem:0,
        bigFeeTypeId: null,
        smallFeeTypeId: null,
        selectedAreaIdList: [],
        isAllArea:0,
      },

      itemList: [],
      specList: [
        {
          specName: '',
          specValue: ''
        },
        {
          specName: '',
          specValue: ''
        }
      ],
      selectedItemList: [],

      guaranteeTypeList:  [],
      treeData: [],
      // treeLoadNode: async (node, resolve) => {
      //   if (node.level === 0) {
      //     return resolve(await this.getAreaList(0));
      //   }
      //   const { id } = node.data;
      //   const res = await this.getAreaList(id);
      //   this.treeData = res;
      //
      //   return resolve(res)
      // },
      // treeCheckedKeys: ["608"],
      cascaderProps: {
          lazy: true,
          label: 'areaName',
          value: 'id',
          leafOnly: false,
          multiple: true,
          checkStrictly: true,
          lazyLoad:async (node, resolve) => {
            const { level, value } = node;
            const res = await this.getAreaList(value || 0)
            resolve(res)
          }
        },
      selectedArea: [],
      areaDialogVisible: false,
    }
  },
  async created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId
    this.showAdd=this.permissions["SpecialFeeSubjectAdd"];
    this.showEdit =this.permissions["SpecialFeeSubjectEdit"];
  },
  mounted() {
    this.getData();
  },
  watch: {
    selectedAreaList: {
      handler(cur){
        if(cur.length){
          this.formData.isAllArea = 0
        }else {
          this.formData.isAllArea = 1
        }
      },
      deep: true,
      immediate: true
    },
    // treeData: {
    //   handler(cur){
    //     if(this.selectedArea && this.selectedArea.length){
    //       for(let i = 0; i < this.selectedArea.length; i++){
    //         const id = this.selectedArea[i]
    //         const node = this.$refs['areaTree'].getNode(id)
    //         if(node && !node.indeterminate) node.indeterminate = true
    //       }
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // }
    // 'formData.selectedAreaIdList':{
    //   handler(cur){
    //     if(cur && cur.length){
    //       this.$refs.areaTable.setCheckboxRow(
    //         this.areaList.filter(item =>
    //           cur.includes(item.id)
    //         ),
    //         true
    //       );
    //     }
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  methods: {
    buttonAddClickEvent() {
      this.areaDialogVisible = !this.areaDialogVisible
    },
    areaItemDel(row) {
      const {id, areaName} = row;
      const ind = this.selectedAreaList.findIndex(el => el.id === id);
      this.$alert(`是否删除地区：${areaName}`, '提示', {
        confirmButtonText: '确定',
        callback: action => {
          if('confirm' === action){
            this.selectedAreaList.splice(ind,1)
            this.$message({
              type: 'success',
              message: '删除成功'
            });
          }
        }
      });
    },
    areaDialogAdd() {
      const target = this.$refs['cascader'].getCheckedNodes()
      target.forEach(el => {
        const {data} = el;
        const flag = this.selectedAreaList.find(el => el.id === data.id)
        if(!flag) this.selectedAreaList.push(data)
      })
      this.buttonAddClickEvent()
    },
    selectChangeEvent(e){
      console.log(e,'selectChangeEvent')
    },
    treeCheck(checkedNodes, {checkedKeys}) {
      // this.treeCheckedKeys = checkedKeys;
      console.log('treeCheck :',checkedKeys)
    },
    // 判断选项是否应禁用（排除当前行）
    isOptionDisabled(currentRow, value) {
      return this.specList.some(
        row => row !== currentRow && row.specName === value
      )
    },

    // 产品批量删除
    handleDeleteItemList() {
      if (this.selectedItemList.length === 0) {
        this.$message.warning('请先勾选产品')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.selectedItemList.forEach(item0 => {
            this.itemList = this.itemList.filter(item => item.id !== item0)
          })
        })
      }
    },

    // 产品删除
    handleDeleteItem(id) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.itemList = this.itemList.filter(item => item.id !== id)
      })
    },

    // 产品复选框
    itemSelectChangeEvent({records}) {
      this.selectedItemList = records.map(item => item.id)
      console.log('产品选中', this.selectedItemList)
    },

    // 弹框选中
   commitSelectedRow(data) {
      console.log(data, '弹框选中')
      let temp = this.itemList
      if (temp.length === 0) {
        this.itemList = data
      } else {
        data.forEach(item => {
          temp.push(item)
        })
      }
    },

    // 保修类型复选框
    guaranteeTypeSelectChangeEvent({records}) {
      // this.selectedGuaranteeTypeIdList = records.map(item => item.id)
      if (this.$refs.guaranteeTypeTable.isAllCheckboxChecked()){
        this.formData.selectedGuaranteeTypeIdList.push(0);
        this.formData.isAllGuaranteeType = 1;
      }else{
        this.formData.isAllGuaranteeType = 0;
        const tableData = this.$refs.guaranteeTypeTable.getCheckboxRecords();
        var guaranteeType = [];
        for (let i = 0; i < tableData.length; i++) {
          guaranteeType.push(tableData[i].id)
        }
        this.formData.selectedGuaranteeTypeIdList = guaranteeType;
      }
    },

    // 品牌复选框
    brandSelectChangeEvent({records}) {
      // this.selectedBrandIdList = records.map(item => item.id)
      if (this.$refs.brandTable.isAllCheckboxChecked()){
        this.formData.selectedBrandIdList.push(0);
        this.formData.isAllBrand = 1;
      }else{
        this.formData.isAllBrand = 0;
        const tableData = this.$refs.brandTable.getCheckboxRecords();
        var brandId = [];
        for (let i = 0; i < tableData.length; i++) {
          brandId.push(tableData[i].id)
        }
        this.formData.selectedBrandIdList = brandId;
      }
    },

    // 服务品类复选框
    itemCategorySelectChangeEvent({records}) {
      // 拿到所有id
      // let temp = records.map(item => item.id)
      //
      // // 获取有子类的父id
      // let parentTemp = new Set()
      // records.forEach(item => {
      //   if (item.parentId != 0) {
      //     parentTemp.add(item.parentId)
      //   }
      // })
      //
      // // 去除有子类的父id
      // let temp1 = []
      // temp.forEach(item => {
      //   if (!parentTemp.has(item)) {
      //     temp1.push(item)
      //   }
      // })
      // this.selectedItemCategoryIdList = temp1
      // console.log('选中的服务品类id', temp1)
      if (this.$refs.itemCategoryTable.isAllCheckboxChecked()){
        this.formData.selectedItemCategoryIdList.push(0);
        this.formData.isAllItemCategory = 1;
      }else{
        this.formData.isAllItemCategory = 0;
        const tableData = this.$refs.itemCategoryTable.getCheckboxRecords();
        var itemCategoryId = [];
        for (let i = 0; i < tableData.length; i++) {
          itemCategoryId.push(tableData[i].id)
        }
        this.formData.selectedItemCategoryIdList = itemCategoryId;
      }

    },

    // 服务类型复选框
    serviceTypeSelectChangeEvent({records}) {
      // 拿到所有id
      // let temp = records.map(item => item.id)
      //
      // // 获取有子类的父id
      // let parentTemp = new Set()
      // records.forEach(item => {
      //   if (item.parentId != 0) {
      //     parentTemp.add(item.parentId)
      //   }
      // })
      //
      // // 去除有子类的父id
      // let temp1 = []
      // temp.forEach(item => {
      //   if (!parentTemp.has(item)) {
      //     temp1.push(item)
      //   }
      // })
      // this.selectedServiceTypeIdList = temp1
      // console.log('选中的服务类型id', temp1)

      if (this.$refs.serviceTypeTable.isAllCheckboxChecked()){
        this.formData.selectedServiceTypeIdList.push(0);
        this.formData.isAllServiceType = 1;
      }else{
        this.formData.isAllServiceType = 0;
        const tableData = this.$refs.serviceTypeTable.getCheckboxRecords();
        var serviceTypeId = [];
        for (let i = 0; i < tableData.length; i++) {
          serviceTypeId.push(tableData[i].id)
        }
        this.formData.selectedServiceTypeIdList = serviceTypeId;
      }
    },

    // 区域复选框
    areaSelectChangeEvent({ checked, records, type }) {
      if(type === 'checkbox-all') {
        this.formData.selectedAreaIdList = checked ? this.areaList.map(item => item.id) : [];
        this.formData.isAllArea = checked ? 1 : 0;
      } else {
        this.formData.selectedAreaIdList = records.map(item => item.id);
      }
    },


    // 新增数据时初始化
    init() {
      this.$http({
        url: api.sfSpecialFeeSubject.initDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        let data = res.data.data
        this.formData.itemCategoryList = data.itemCategoryList
        this.formData.serviceTypeList = data.serviceTypeList
        this.formData.snCompanyBrandList = data.snCompanyBrandList
        this.formData.sfSpecialFeeSubjectConditionDTO = data.sfSpecialFeeSubjectConditionDTO
        this.guaranteeTypeList = [{id: 1, type: '保内'}, {id: 2, type: '保外'}, {id: 3, type: '未知'}]
        // this.areaList = data.areaList
      })
    },
    loadChildrenMethod (scope) {
      const { row } = scope
      // 异步加载子节点
      return new Promise(async resolve => {
        const res = await this.getAreaList(row.id)

        res.forEach(el => {
          el.checkFlag = this.formData.selectedAreaIdList.includes(el.id)
        })
        resolve(res)
      })
    },
    getAreaList(parentId) {
      return new Promise((resolve) => {
        this.$http({
          url: api.sfSpecialFeeSubject.areaList,
          method: 'post',
          data: {
            companyId: '',
            parentId: parentId|| 0
          },
          isLoading: true,
          modalStrictly: true,
        }).then(res => {
          const temp = res.data.data;
          temp.forEach(el => {
            el.hasChild = true
          })
          resolve(temp)
        })
      })
    },
    findTreeList(ids) {
      return new Promise((resolve,reject) => {
          this.$http({
            url: api.sfSpecialFeeSubject.findTreeList,
            method: 'post',
            data: {
              ids
            },
            isLoading: true,
            modalStrictly: true,
          }).then( res => {
              resolve(res.data.data)
          })
      })
    },
    // 回显
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.sfSpecialFeeSubject.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(async response => {
          let data = response.data.data || {}
          this.areaList = await this.getAreaList()
          this.selectedAreaList = data.areaList.filter(Boolean)
          // const target = await this.findTreeList(data.selectedAreaIdList)
          // const temp = target.map(el => {
          //   if(el.includes(',')){
          //     return el.split(',')
          //   }else {
          //     return el
          //   }
          // })
          // this.selectedAreaList = Array.from(new Set(temp.flat()))
          // console.log(this.areaList,'this.areaList=========')
          // this.selectedArea = target;


          // const temp = target.map(el => {
          //   if(el.includes(',')){
          //     return el.split(',')[0]
          //   }else {
          //     return el
          //   }
          // })
          // console.log(temp,'findTreeList')

          // const array = target.map(el => {
          //   if(el.includes(',')){
          //     return el.split(',')
          //   }else {
          //     return el
          //   }
          // })
          //
          // this.selectedArea = Array.from(new Set(array.flat()))
          // this.selectedArea.forEach(el => {
          //   const node = this.$refs['areaTree'].getNode(el)
          //   if(node) node.indeterminate = true
          // })

          console.log(data,'=============????')
          // lengthValue 长度值，diameterValue 直径值
          const { lengthValue, diameterValue } = data;
          if(lengthValue){
            this.specList.splice(0,1,{specName: '1',specValue: lengthValue})
          }
          if(diameterValue){
            this.specList.splice(1,1,{specName: '2',specValue: diameterValue})
          }
          // this.areaList = JSON.parse(JSON.stringify(data.areaList))
          // delete data.areaList
          let tempList = []
          tempList.push(data.beginDate)
          tempList.push(data.endDate || '')
          data.date = tempList
          this.formData = data
          this.guaranteeTypeList = [{id: 1, type: '保内'}, {id: 2, type: '保外'}, {id: 3, type: '未知'}]

          this.setListData(data)
          // this.loadProductOption1()
        })
      } else {
        this.init()
      }
    },

    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          if (!this.formData.unit) {
            this.$message.warning('请输入单位')
            return
          }
          if (this.formData.selectedGuaranteeTypeIdList == null || this.formData.selectedGuaranteeTypeIdList.length == 0) {
            this.$message.warning('请选择保修类型')
            return
          }
          if (this.formData.selectedBrandIdList == null || this.formData.selectedBrandIdList.length == 0) {
            this.$message.warning('请选择品牌')
            return
          }

          if (this.formData.selectedItemCategoryIdList == null || this.formData.selectedItemCategoryIdList.length == 0) {
            this.$message.warning('请选择产品类型')
            return
          }

          if (this.formData.selectedServiceTypeIdList == null || this.formData.selectedServiceTypeIdList.length == 0) {
            this.$message.warning('请选择服务类型')
            return
          }

          if (this.formData.bigFeeTypeId == null || this.formData.bigFeeTypeId == 0) {
            this.$message.warning('请选择费用大类')
            return;
          }

          if (this.formData.smallFeeTypeId == null || this.formData.smallFeeTypeId == 0) {
            this.$message.warning('请选择费用小类')
            return;
          }

          if (this.itemList != null && this.itemList.length !== 0) {
            let idList = this.itemList.map(item => item.id)
            this.formData.basItemIdList = idList
          } else {
            this.formData.basItemIdList = [0]
            this.formData.isAllItem = 1
            // this.$message.warning('请选择产品')
            // return
          }
          let date = this.formData.date;
          if (date != null && date.length > 0) {
            this.formData.beginDate = date[0]
            this.formData.endDate = date[1]
          }else{
            this.$message.error('请输入对应的有效时间！')
            return
          }

          for(const item of this.specList){
            if(Object.keys(item).length){
              const { specName, specValue } = item;
              if(specName === '1'){
                // lengthValue 长度值，diameterValue 直径值
                this.formData.lengthValue = specValue
              }else if(specName === '2'){
                this.formData.diameterValue = specValue
              }
            }
          }

          this.formData.selectedAreaIdList = this.selectedAreaList.map(item => item.id);
          this.$baseConfirm('您确定要保存吗？').then(() => {
            // if (this.selectedGuaranteeTypeIdList != null && this.selectedGuaranteeTypeIdList.length !== 0) {
            //   let temp = this.selectedGuaranteeTypeIdList.sort()
            //   this.formData.sfSpecialFeeSubjectConditionDTO.guaranteeType = temp.join(';')
            // } else {
            //   this.$message.warning('请选择保修类型')
            //   return
            // }
            //
            // if (this.selectedBrandIdList != null && this.selectedBrandIdList.length !== 0) {
            //   let temp = this.selectedBrandIdList.sort()
            //   this.formData.sfSpecialFeeSubjectConditionDTO.brandId = temp.join(';')
            // } else {
            //   this.$message.warning('请选择品牌')
            //   return
            // }
            //
            // if (this.selectedItemCategoryIdList != null && this.selectedItemCategoryIdList.length !== 0) {
            //   let temp = this.selectedItemCategoryIdList.sort()
            //   this.formData.sfSpecialFeeSubjectConditionDTO.smallCategoryId = temp.join(';')
            // } else {
            //   this.$message.warning('请选择产品类型')
            //   return
            // }
            //
            // if (this.selectedServiceTypeIdList != null && this.selectedServiceTypeIdList.length !== 0) {
            //   let temp = this.selectedServiceTypeIdList.sort()
            //   this.formData.sfSpecialFeeSubjectConditionDTO.serverTypeId = temp.join(';')
            // } else {
            //   this.$message.warning('请选择服务类型')
            //   return
            // }
            //
            // if (this.itemList != null && this.itemList.length !== 0) {
            //   let idList = this.itemList.map(item => item.id)
            //   idList = idList.sort()
            //   this.formData.sfSpecialFeeSubjectConditionDTO.itemId = idList.join(';')
            // } else {
            //   this.$message.warning('请选择产品')
            //   return
            // }
            this.$mask.open()
            console.log(this.formData,'this.formData========>')
            this.$http({
              url: this.isEdit ? api.sfSpecialFeeSubject.updateDataUrl : api.sfSpecialFeeSubject.addDataUrl,
              method: 'post',
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              this.$emit('goBackIndex')
              // this.$baseReload()
              this.$mask.close()

            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
              this.$mask.close()

            })
          })
        }
      })
    },

    setListData(data) {
      // if (data.sfSpecialFeeSubjectConditionDTO.brandId != null) {
      //   this.selectedBrandIdList = data.sfSpecialFeeSubjectConditionDTO.brandId.split(';')
      // }
      // if (data.sfSpecialFeeSubjectConditionDTO.smallCategoryId != null) {
      //   this.selectedItemCategoryIdList = data.sfSpecialFeeSubjectConditionDTO.smallCategoryId.split(';')
      // }
      // if (data.sfSpecialFeeSubjectConditionDTO.serverTypeId != null) {
      //   this.selectedServiceTypeIdList = data.sfSpecialFeeSubjectConditionDTO.serverTypeId.split(';')
      // }
      // if (data.sfSpecialFeeSubjectConditionDTO.guaranteeType != null) {
      //   let list = data.sfSpecialFeeSubjectConditionDTO.guaranteeType.split(';')
      //   this.selectedGuaranteeTypeIdList = []
      //   list.forEach(item => {
      //     this.selectedGuaranteeTypeIdList.push(Number(item))
      //   })
      // }
      if (data.basItemIdList != null && data.basItemIdList != '') {
        let list = data.basItemIdList
        this.$http({
          url: api.basItem.getDataByIdsUrl,
          method: 'post',
          data: {ids: list}
        }).then(res => {
          let list = res.data.data
          if (list != null && list.length !== 0) {
            this.itemList = []
            list.forEach(item => {
              this.itemList.push(item)
            })
          }
        })
      }
      // if (data.sfSpecialFeeSubjectConditionDTO.itemId != null && data.sfSpecialFeeSubjectConditionDTO.itemId != '') {
      //   let list = data.sfSpecialFeeSubjectConditionDTO.itemId.split(';');
      //   this.$http({
      //     url: api.basItem.getDataByIdsUrl,
      //     method: 'post',
      //     data: {ids: list}
      //   }).then(res => {
      //     let list = res.data.data
      //     if (list != null && list.length !== 0) {
      //       this.itemList = []
      //       list.forEach(item => {
      //         this.itemList.push(item)
      //       })
      //     }
      //   })
      // }
    },
    cascaderChange(e){
      console.log('当前选中值（含非叶子节点）:', e);
    }

  },
};

</script>
<style lang="scss" scoped>
// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

.current-info {
  margin-left: 5px;
  margin-right: 5px;
}

.item-button {
  margin-right: 0.5vw;
  // margin-top: 5px;
}

/*滚动条整体部分*/
.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
/*滚动条的轨道*/
.mytable-scrollbar ::-webkit-scrollbar-track {
  background-color: #FFFFFF;
}
/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #F1F1F1;
  box-shadow: inset 0 0 6px rgba(0,0,0,.3);
}
.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
  background-color: #A8A8A8;
}
.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}
/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
  background-color: #FFFFFF;
}


::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
.btn_zdy {
  // margin: 5px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

//::v-deep .el-input .el-input__inner{
//  height: auto!important;
//  line-height: 1;
//}
</style>
